import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiUploadS3State {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: CiUploadS3State = { state: 'pending' };

export const ciUploadS3Reducer = createReducer(
    initialState,
    on(identityCardActions.uploadS3, (state) => ({ ...state, state: 'loading' as const })),
    on(identityCardActions.uploadS3Success, (state) => ({ ...state, state: 'loaded' as const })),
    on(identityCardActions.uploadS3Fail, (state) => ({ ...state, state: 'error' as const })),
    on(identityCardActions.clearUploadS3, () => initialState)
);
